import { extract } from '../extractors/protocolFundamentals';
import { fmtUSD } from '../extractors/_shared';

export function buildPromptBlock(project, a) {
  const d = extract(project, a);
  if (!d) return '';
  const lines = [`【协议基本面（${d.source}）】`];
  if (d.perpVolume24h != null) lines.push(`Perp 24h 成交: ${fmtUSD(d.perpVolume24h)}`);
  if (d.totalOI != null)       lines.push(`Perp Total OI: ${fmtUSD(d.totalOI)}`);
  if (d.activeMarkets != null) lines.push(`活跃市场数: ${d.activeMarkets}`);
  if (d.perpFees30d != null)   lines.push(`30日手续费: ${fmtUSD(d.perpFees30d)}`);
  if (d.revenue30d != null)    lines.push(`30日协议收入: ${fmtUSD(d.revenue30d)}`);
  if (d.perpDau30d != null)    lines.push(`30日日均活跃交易者: ${d.perpDau30d.toLocaleString()}`);
  if (d.perpDauLatest != null) lines.push(`最新日活跃交易者: ${d.perpDauLatest.toLocaleString()}`);
  if (d.stakedHype != null)    lines.push(`质押 HYPE: ${d.stakedHype.toLocaleString()} HYPE`);
  if (d.fundingRate != null)   lines.push(`资金费率: ${(d.fundingRate*100).toFixed(4)}%`);
  if (d.longShortRatio != null)lines.push(`多空比: ${d.longShortRatio.toFixed(2)}`);
  if (d.openInterest != null)  lines.push(`期货持仓: ${fmtUSD(d.openInterest)}`);
  if (d.topAssets.length) {
    lines.push(`Top 5 永续市场: ${d.topAssets.slice(0, 5).map(t => `${t?.name || t?.coin}(${fmtUSD(t?.volume24h)})`).join(', ')}`);
  }
  return lines.join('\n');
}
